import { Select } from "@/components/Select";
import { Controller, useFormContext } from "react-hook-form";

const OnboardingSelect = (props: IMatConfigurationSelectProperty) => {
  const { identifier, options, value } = props;
  const { control } = useFormContext();

  const getDefaultValue = () =>
    options.find(option => option.value === value) ?? {
      label: "",
      value: "",
    };

  return (
    <Controller
      name={identifier}
      control={control}
      defaultValue={getDefaultValue()}
      render={({ field }) => <Select closeMenuOnSelect {...props} {...field} />}
    />
  );
};

export default OnboardingSelect;
